import './styles/globals.css';

import { initDependencies, setupDependencies } from './app';

setupDependencies();

initDependencies();

const { runApp } = require('./services/runApp');
runApp();

type HotCapableModule = NodeJS.Module & {
  hot?: { accept: () => void };
};

const mod = module as HotCapableModule;

if (mod.hot) {
  mod.hot.accept();
}
